import { render } from "./AboutSectionXxl.vue?vue&type=template&id=38b92758&scoped=true"
import script from "./AboutSectionXxl.vue?vue&type=script&lang=js"
export * from "./AboutSectionXxl.vue?vue&type=script&lang=js"

import "./AboutSectionXxl.vue?vue&type=style&index=0&id=38b92758&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38b92758"]])

export default __exports__